<template>
  <dialog class="dialog-modal-no-bg" :aria-label="trans('lms.Description')">
    <div class="modal-dialog" role="document">
      <form ref="form" v-on:submit.prevent="onSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <label class="form-label" for="file_description_modal_title">{{ trans('lms.filename') }}</label>
            <input
              type="text"
              class="modal-title form-control"
              id="file_description_modal_title"
              name="fileName"
              required
              maxlength="100"
              v-model="file_name"
              tabindex="0"
              ref="filename_input"
            />
            <button
              type="button"
              class="close"
              :aria-label="trans('lms.close')"
              @click="closeModal"
              tabindex="0"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <input type="hidden" name="_token" :value="csrf" />
          <input type="hidden" name="fileId" :value="this.file.delete_id ?  this.file.delete_id : this.file.id" />
          <input  tabindex="0" v-for="tag in tags" :key="tag.hasOwnProperty('text') ? tag.text : tag" type="hidden" name="tags[]" :value="tag.hasOwnProperty('text') ? tag.text : tag" />
          
          <div class="modal-body">
            <div class="label-form" v-if="this.file.model_type == 'App\\Client'">
              <label class="form-label" for="fileMulticlient">{{ trans('lms.MeetingSeries.Multiclient') }}</label>
              <input  tabindex="0" type="checkbox"  v-model="multiclient" id="fileMulticlient" name="fileMulticlient" :checked="this.multiclient" />
            </div>

            <div class="label-form">
              <label class="form-label" for="fileDescription">{{ trans('lms.Description') }}</label>
              <textarea
                class="form-control"
                id="fileDescription"
                name="fileDescription text-resize"
                v-model="description"
                maxlength="255"
                tabindex="0"
              ></textarea>
              <vue-tags-input v-if="!max_accessibility" v-model="tag" :tags="tags" :placeholder="trans('lms.EnterTags')" @tags-changed="newTags => tags = newTags" :autocomplete-items="filteredItems" :autocomplete-min-length="1"/>
            </div>
          </div>
          <div class="modal-footer">
            <div class="error-message alert alert-danger" v-if="error">{{errorMessage}}</div>
            <button
                tabindex="0"
              type="button"
              class="btn btn-secondary neutral"
              data-dismiss="modal"
              @click="closeModal"
            >{{ trans('lms.close') }}</button>
            <button  tabindex="0" type="submit" class="btn btn-primary positive">{{ trans('lms.save') }}</button>
          </div>
        </div>
      </form>
    </div>
  </dialog>
</template>
<script>
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueTagsInput from "@johmun/vue-tags-input";
Vue.use(VueAxios, axios);
export default {
  props: ["show", "file", "max_accessibility"],
  data() {
    return {
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      modalShown: this.show,
      description: "",
      multiclient: 0,
      input_empty: true,
      file_name: "",
      tag: '',
      tags: [],
      tag_list: [],
      error: false,
      errorMessage: "",
      allTagsList: []
    };
  },
  watch: {
    show(show) {
      if(show){
        this.$el.addEventListener('close', (e) => this.closeModal(e), { once: true });
        this.$el.showModal();
      }

      this.modalShown = show;
      this.description = show ? this.file.info.description : "";
      this.multiclient = show ? this.file.info.multiclient : 0;
      this.file_name = show ? this.file.name : "";
      this.tags = show ? this.file.tags : [];
      if (show) {
          this.$refs.filename_input.focus();
        setTimeout(() => {
          this.$refs.filename_input.focus();
        }, 100)
      }
    },
    description() {
      this.description ? (this.input_empty = false) : (this.input_empty = true);
    }
  },
  mounted() {
    this.getAllTags();
  },
  computed: {
    filteredItems() {
      return this.allTagsList.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
  },
  methods: {
    closeModal(e) {
      this.$emit("modal_closed", { file_id: this.file.id, tags: this.tags, multiclient: this.multiclient, description: this.description, name: this.file_name });
      this.modalShown = false;
      this.description = "";
      this.multiclient = 0;
      this.file_name = "";
      this.error = false;
      this.errorMessage = "";

      if(e.type != 'close') {
        this.$el.close();
      }
    },
    showError(error){
      this.error = true;
      this.errorMessage = error;
    },
    getAllTags(){
      axios.get("/media/alltags").then((response) => {
          this.allTagsList = response.data;
      });
    },
    async onSubmit(e){
      this.tag_list = [];
      this.tags.forEach(tag => {
          this.tag_list.push(tag.hasOwnProperty('text') ? tag.text : tag);
      });
      axios.post(
        '/media/change/file', 
        { 
          fileName: this.file_name,
          fileDescription: this.description,
          fileMulticlient: this.multiclient,
          _token: this.csrf,
          fileId: this.file.id,
          tags: this.tag_list
          }
      ).then((response)=>{
        let newData = []
        if(response.data.files){
          newData = response.data.files.filter(file => file.id == this.file.id);
        } else{
          newData[0] = response.data;
        }
        this.tag_list = [];
        this.description = newData[0].info.description;
        this.multiclient = newData[0].info.multiclient;
        this.file_name = newData[0].name;
        newData[0].info.tags.forEach(tag => {
          this.tag_list.push(tag.name);
        });
        this.tags = this.tag_list;
        this.getAllTags();
        this.closeModal(e);
      }).catch((error)=>{
        if(error.response){
          this.showError(error.response.data.message);
        }
      });
     
      
    }
  }
};
</script>
<style scoped>
.text-resize{
  resize: vertical;
}
.close{
  font-size:2.3em;
}
.label-form-container {
  position: relative;
}
.form-label {
  font-size: 0.8em;
}
.transition {
  width: 80%;
  max-width: 600px;
  position: fixed;
  z-index: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
    animation-duration: 1s;
  animation-name: slidein;
}
@keyframes slidein {
  from {
   top: 5%;
  left: 50%;
  transform:translate(-50%, -50%);
  }
  to {
     top: 50%;
    left: 50%;
    transform:translate(-50%, -50%);
  }
  }
.transition .modal-dialog{
  margin-top: 0 !important;
}
.showModal {
  pointer-events: all;
  display: block;
}
#file_description_modal_title {
  max-width: 90%;
  float: left;
}
.modal-header{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.error-message{
  text-align: left;
  padding: 15px;
  left: 15px;
  bottom: -13px;
}

#file_description_modal_title {
  margin-right: 7px;
  margin-left: 7px;
}
.modal-dialog{
  max-width: 100%;
}
@media screen and (max-width: 425px) {
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/filedescription.vue